import { createContext } from 'react';

const SettingsScreenContext = createContext( null );

export default SettingsScreenContext;